import axios from 'axios'

const Http = (function() {
  const instance = axios.create({
    baseURL: '//' + globalConfig.ysappItemBasePath + '/yunjiysapp',
    withCredentials: true
  })
  
  instance.interceptors.response.use((res) => {
    return res.data
  }, (error) => {
    Toast('网络错误')
    return Promise.reject(error)
  })

  return instance
})()

// 查询时间轴
export const queryTimesAxisTabs = (params = {}) => Http.get('/app/queryTimesAxisTabs.json', { params })
// 新版本分类页TAB接口
export const queryCategoryByChannelTab = (params = {}) => Http.get('/app/queryCategoryByChannelTab', {params})
// 加载个性化CTA商品，替换大接口传过来的数据
export const queryModuelItemMeetingplace = (params = {}) => Http.get('/app/queryModuelItemMeetingplace.json', {params})
// dataType 1-限时抢购 2-新品速递
export const queryPageModuleTabItempolymer = (params = {}) => Http.get('/app/queryPageModuleTabItempolymer.json', { params })
// dataType  1-banner  2-蛋坑 
export const queryPageModuleTabResourceImg = (params = {}) => Http.get('/app/queryPageModuleTabResourceImg.json', { params })
// 推荐商品
export const queryPageModuleTabRecommend = (params = {}) => Http.get('/app/queryPageModuleTabRecommend.json', { params })
// 查询分类页新品Tab下时间轴商品
export const queryCategoryNewItemTabAxisItems = (params = {}) => Http.get('/app/queryCategoryNewItemTabAxisItems.json', { params })
// CTA模块
export const queryModuleTabCtaBo = (params = {}) => Http.get('/app/queryModuleTabCtaBo.json', { params })
// 获取灰度字段接口
export const queryGrayAndBottomBar = (params = {}) => Http.get('/app/queryGrayAndBottomBar.json', { params })